// MB를 byte로 변환
export const convertMbToByte = (megaByte: number) => {
  return megaByte * 1024 * 1024;
};
